"use client";

//https://usehooks-ts.com/react-hook/use-media-query
import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { useIsomorphicLayoutEffect } from "./useIsomorphicLayoutEffect.js";
const IS_SERVER = typeof window === "undefined";
export function useMediaQuery(query, t0) {
  const $ = _c(17);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    defaultValue: t2,
    initializeWithValue: t3
  } = t1;
  const defaultValue = t2 === undefined ? false : t2;
  const initializeWithValue = t3 === undefined ? true : t3;
  let t4;
  if ($[2] !== defaultValue) {
    t4 = query_0 => {
      if (IS_SERVER) {
        return defaultValue;
      }
      return window.matchMedia(query_0).matches;
    };
    $[2] = defaultValue;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const getMatches = t4;
  let t5;
  if ($[4] !== defaultValue || $[5] !== getMatches || $[6] !== initializeWithValue || $[7] !== query) {
    t5 = () => {
      if (initializeWithValue) {
        return getMatches(query);
      }
      return defaultValue;
    };
    $[4] = defaultValue;
    $[5] = getMatches;
    $[6] = initializeWithValue;
    $[7] = query;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const [matches, setMatches] = useState(t5);
  let t6;
  if ($[9] !== getMatches || $[10] !== query) {
    t6 = function handleChange() {
      setMatches(getMatches(query));
    };
    $[9] = getMatches;
    $[10] = query;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const handleChange = t6;
  let t7;
  if ($[12] !== handleChange || $[13] !== query) {
    t7 = () => {
      const matchMedia = window.matchMedia(query);
      handleChange();
      if (matchMedia.addListener) {
        matchMedia.addListener(handleChange);
      } else {
        matchMedia.addEventListener("change", handleChange);
      }
      return () => {
        if (matchMedia.removeListener) {
          matchMedia.removeListener(handleChange);
        } else {
          matchMedia.removeEventListener("change", handleChange);
        }
      };
    };
    $[12] = handleChange;
    $[13] = query;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== query) {
    t8 = [query];
    $[15] = query;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  useIsomorphicLayoutEffect(t7, t8);
  return matches;
}